module.exports = __webpack_public_path__ + "img/b257fa9.svg";